module.exports = __webpack_public_path__ + "files/bb1e4b225d37ff7b7aef88c5784ab43f.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/smileys_emotion-4.png
// module id = 500
// module chunks = 76